import React from 'react';
import Tabbar from 'containers/Tabbar/Tabbar';
import MobileNavbar from 'components/MobileNavbar';
import MaxWidthContainer from 'components/MaxWidthContainer';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';

const RootContainer = styled(MaxWidthContainer, { shouldForwardProp: prop => prop !== 'hasNavbar' })`
  width: 100%;
  height: 100%;

  ${({ hasNavbar }) => hasNavbar && css`
    padding-top: calc(var(--navbar-height) + var(--safe-area-inset-top));
  `}
`;

const Content = styled('div')`
  height: 100%;
  padding-top: 1.5rem;
`;

const MobileCommonLayout = ({ children, navbarProps = {}, tabbar = true, widthVariant, disableGutters }) => {
  return (
    <RootContainer hasNavbar={Boolean(navbarProps)} widthVariant={widthVariant} disableGutters={disableGutters}>
      {navbarProps && <MobileNavbar {...navbarProps} />}
      <Content>{children}</Content>
      {tabbar && <Tabbar />}
    </RootContainer>
  );
};

MobileCommonLayout.propTypes = {
  tabbar: PropTypes.bool,
  navbarProps: PropTypes.object,

  widthVariant: PropTypes.oneOf(['default', 'medium', 'wide']),

  disableGutters: PropTypes.bool,
};

export default MobileCommonLayout;
